import { Component } from '@angular/core';
import { MockCallServiceService } from './mock-call-service.service';

@Component({
  selector: 'app-mock-call-wrapper',
  templateUrl: './mock-call-wrapper.component.html',
  styleUrls: ['./mock-call-wrapper.component.scss'],
})
export class MockCallWrapperComponent {
  popups: any[] = [];

  constructor(private mockCallService: MockCallServiceService) {
    this.mockCallService.openedPopups$.subscribe(popups => {
      this.popups = popups;
    });
  }

  onPopupClose(busId: string): void {
    this.mockCallService.removePopup(busId);
  }
}
